class SectionVideos extends HTMLElement {
  constructor(){
    super();

    this.catButtons = this.querySelectorAll('nav button');
    this.catButtons.forEach((el) => {
      el.addEventListener('click', (e) => this.filterCategory(e));
    });

    const defaultAll = this.querySelector('nav button.js-reset');
    if (defaultAll) {
      defaultAll.click();
    }

    this.videoItems = this.querySelectorAll('.video__grid-item');
  }

  filterCategory(evt) {
    const self = evt.target;
    const parent = self.closest('nav');
    const dropdown = parent.querySelector('.is-dropdown');

    if (self.classList.contains('is-dropdown')) {
      self.classList.toggle('activate-dropdown');
    }

    else {
      if (self.classList.contains('js-reset')) {
        this.catButtons.forEach(el => el.classList.remove('active'));
        self.classList.add('active');

        [...this.videoItems].forEach((el) => el.classList.remove('hide'));
      }

      else {
        this.catButtons.forEach(el => el.classList.remove('active'));
        self.classList.add('active');

        [...this.videoItems].forEach((el) => el.classList.add('hide'));
        [...this.videoItems].forEach((el) => {
          if (el.classList.contains(self.dataset.cat)) {
            el.classList.remove('hide');
          }
        });
      }

      if (dropdown && dropdown.classList.contains('activate-dropdown')) {
        dropdown.classList.remove('activate-dropdown');
        dropdown.innerText = self.innerText;
      }
    }
  }
}

if (!customElements.get('section-videos')){
  customElements.define('section-videos', SectionVideos);
}
